import jMoment from "moment-jalaali";
const FORMAT_FULL = `jYYYY/jMM/jDD HH:mm`;
const FORMAT_GREGORIAN = "YYYY-MM-DDTHH:mm:ss";
const FORMAT_DATE = `jYYYY/jMM/jDD`;
const FORMAT_TIME = `HH:mm`;
export const getDateTimeFull = (timestamp) => {
    if (!timestamp)
        return "";
    return jMoment(timestamp).format(FORMAT_FULL);
};
export const getDateOnly = (timestamp) => {
    if (!timestamp || !jMoment(timestamp).isValid())
        return "";
    return jMoment(decodeURIComponent(timestamp)).format(FORMAT_DATE);
};
export const getTimeOnly = (timestamp) => {
    if (!timestamp)
        return "";
    return jMoment(timestamp).format(FORMAT_TIME);
};
export const getRelationalDate = (timestamp) => {
    if (!timestamp)
        return "";
    jMoment.locale("fa-IR");
    jMoment.loadPersian();
    return jMoment(timestamp).fromNow();
};
export const convertPersianTimeToTimeStamp = (timestamp) => {
    const dateStamp = new Date(timestamp);
    return encodeURIComponent(jMoment(dateStamp).format());
};
export const getRelationalInDays = (dateString) => {
    if (!dateString)
        return 0;
    return jMoment(dateString, FORMAT_DATE).diff(jMoment(), "days");
};
export const convertTimeStampToGregorianTime = (timestamp) => {
    if (timestamp) {
        return jMoment(timestamp).format(FORMAT_GREGORIAN);
    }
    return "";
};
export const convertPersianDateToDateTime = (dateString) => {
    return jMoment(dateString, FORMAT_DATE).toDate();
};
